import React from "react";
import NotFound from "../../assets/summary/NotFound.svg";
import IconTitle from "../shared/components/IconTitle";
import Text from "../shared/components/Text";
import { Box, Grid } from "@material-ui/core";

export function NotFoundView() {
  return (
    <>
      <Box style={{ height: "25vh" }} />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className="p-2"
      >
        <Grid item>
          <IconTitle
            icon={<img alt="Not found icon" src={NotFound} height="90px" />}
            title={<Text tId="SORRY" />}
            subtitle={<Text tId="PAGE_NOT_FOUND" />}
          />
        </Grid>
      </Grid>
    </>
  );
}
